module.exports = __webpack_public_path__ + "img/Pl4.1cd27946.png";